"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YearsOfAge = exports.Excess = exports.State = exports.Scale = exports.IncomeTierNumber = exports.IncomeTier = exports.PaymentMethod = exports.PaymentFrequency = void 0;
const common_1 = require("./common");
exports.PaymentFrequency = common_1.PaymentFrequency.Weekly;
exports.PaymentMethod = common_1.PaymentMethod.DirectDebit;
exports.IncomeTier = common_1.IncomeTier.Tier0;
exports.IncomeTierNumber = common_1.IncomeTierNumber.Tier0;
exports.Scale = common_1.Scale.Single;
exports.State = common_1.State.QLD;
exports.Excess = common_1.Excess[750];
exports.YearsOfAge = 30;